define('responsive-gameday/controllers/FieldViewController',['require','exports','module','jquery','Responsive/controllers/ScrollViewController','../views/render/FieldViewRender','Responsive/util/renderComplete','Responsive/util/dom','message-service/message-service','responsive-gameday-tracking/responsive-gameday-tracking','gameday-resource-path/gameday-resource-path','GameDayCore/GDModel/enums/events/EventTypes','responsive-gameday/views/Monitor/Events/ViewModelUpdateEvents','GameDayCore/GDModel/enums/datasources/Datasources','image-loader/image-loader','Responsive/util/renderComplete','extant/extant','tether/tether'],function(require, exports, module) {
    //(function (win, doc, undef, Re, GameDayUI, $GDC) {

	// Add private variables here
	var $ = require("jquery"),
        ScrollViewController = require("Responsive/controllers/ScrollViewController"),
        FieldViewRender = require( '../views/render/FieldViewRender' ),
        renderComplete = require("Responsive/util/renderComplete"),
        dom = require( "Responsive/util/dom" ),
        MessageService = require("message-service/message-service"),
        Tracking = require("responsive-gameday-tracking/responsive-gameday-tracking"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        EventTypes = require("GameDayCore/GDModel/enums/events/EventTypes"),
        VMEvents = require("responsive-gameday/views/Monitor/Events/ViewModelUpdateEvents"),
        Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
        ImageLoader = require("image-loader/image-loader"),
        renderComplete = require("Responsive/util/renderComplete"),
        exists = require( 'extant/extant' ),
        Tether = require( 'tether/tether' ),
        Superclass,
		hasSVG='SVGAngle' in window;

    var checkboxSelectors = "#checkboxes input[type='checkbox']",
		fieldMarkerClass = 'onthefield-hitchart-marker',
		fieldPlayerFielderClass = 'fielder',
		fieldPlayerRunnerClass = 'runner',
		filedMarkerHoverClass = 'onfield-hover-data';

        //DataHander
    function onBeat(payload, evt) {
        var hitchartRefresh=false;
        if(payload == 'hitchartchange'){
            hitchartRefresh=true;
            payload=null;
        }
        payload=payload||this.requiredData;

        var stadiumID = (exists(payload)) ? payload.venue.id : this.requiredData.venue.id,
            that = this;

        this.requiredData = payload || this.requiredData;
        this.clearHitOutHoverContainers();

        this.viewRender.viewState.showClasses = this.getVisibleClassNames();

        $.extend(this.requiredData.venue, {
            img     : hasSVG ? resourcePath.get('field', {id : stadiumID}) : resourcePath.get('fieldPNG', {id : stadiumID}),
            generic : hasSVG ? resourcePath.get('field') : resourcePath.get('fieldPNG')
        });
            //If it's not an mlb game, just skip right to the generic field
        if(payload.sport_code !== 'mlb'){
            this.requiredData.venue.img = this.requiredData.venue.generic;
        }
        if (this.childWrapper.childNodes.length && this.requiredData.venue.id === this.lastStadium) {
            this.childWrapper.querySelector('.onthefield').outerHTML = this.viewRender.renderPartial('playersView',this.requiredData);
            this.childWrapper.querySelector('.waiting').outerHTML = this.viewRender.renderPartial('deckHoleView',this.requiredData);
        

            renderComplete(function () {

                // Get coordinates of field img
                that.createTetherHoverData();
                that.hideOverlay();
            });
        } else {
            ImageLoader.load(this.requiredData.venue && this.requiredData.venue.img).fail(function () {
                that.requiredData.venue.img = that.requiredData.venue.generic;
            }).always(function () {
                that.childWrapper.innerHTML = that.viewRender.render(that.requiredData);

                renderComplete(function () {
                    that.hideOverlay();
                    that.setScroll();
                    that.onBeat();
                });
            });
        }

        this.lastStadium = this.requiredData.venue.id;
    };

	// Constructor
	function FieldViewController() {
		// Call super constructor
		Superclass.constructor.call(this);
		this.mainRender;
		this.playersRender;
		this.requiredData = {};
		this.lastStadium;
        this.viewRender = new FieldViewRender();
        this.onBeat = function(payload, evt){
            onBeat.call(this,payload, evt)
        }
	}

	// Prototype Inheritence
    ScrollViewController.spawn(FieldViewController).define({
		draw: function () {
			Superclass.draw.call(this);
			this.setClassName("FieldViewController");
		},

        getVisibleClassNames : function(){
            var showClasses=[],
                boxes=$('#checkboxes',this.childWrapper),
                checked=$('input:checked',boxes);
            if(!boxes.length){
                showClasses=[ 'draw-runner', 'draw-fielder' ];
            } else {
                checked.each(function(){
                    showClasses.push(this.getAttribute('data-toggleclass'));
                });
            }
            return showClasses.join(' ');

        },
        clearHitOutHoverContainers: function() {
            var nodes = document.querySelectorAll('.' + filedMarkerHoverClass),
                i = 0,
                len = nodes.length;
            // Clear the absolutely positioned hit/out marker hover data containers
            for(; i < len; i++){
                dom.removeNode(nodes[i]);
            }
        },

        createTetherHoverData: function() {
            var node,
                i=0,
                fieldImgCoords = document.querySelector('section.field .img').getBoundingClientRect(),
                nodes = $('.' + fieldMarkerClass + ':visible',this.childWrapper),
                len = nodes.length,
                fieldHoverData,
                node;

            for(; i < len; i++){
                node=nodes[i];
                fieldHoverData = node.querySelector('.onfield-hover-data');

                /*
                 * If no fieldHoverData found, it is likely that there is an associated
                 * Tether instance already... just skip it.
                 */
                if(node && fieldHoverData) {
                    /*
                     * Create tether object for hit/out data on field
                     */
                    new Tether({
                        element: fieldHoverData,
                        target: node,
                        attachment: 'bottom middle',
                        targetAttachment: 'top middle',
                        offset: '4px 0',
                        constraints: [
                            {
                                to: [fieldImgCoords.left, fieldImgCoords.top, fieldImgCoords.right, fieldImgCoords.bottom],
                                attachment: 'together',
                                pin: true
                            }
                        ]
                    });

                    // Show hit/out data on hover
                    node.addEventListener('mouseenter', function(fieldDivWithHoverData) {
                        var id = fieldDivWithHoverData.currentTarget.getAttribute('data-identifier');
                        var hoverData = document.querySelector('.' + id);
                        if(hoverData) {
                            hoverData.style.visibility = 'visible';
                            hoverData.style.opacity = '0.9';
                            hoverData.style.zIndex = '99999';
                        }
                    });

                    // Hide hit/out data when your mouse leaves the hit/out marker
                    node.addEventListener('mouseleave', function(fieldDivWithHoverData) {
                        var id = fieldDivWithHoverData.currentTarget.getAttribute('data-identifier');
                        var hoverData = document.querySelector('.' + id);
                        if(hoverData) {
                            hoverData.style.visibility = null;
                            hoverData.style.opacity = null;
                            hoverData.style.zIndex = null;
                        }
                    });
                }
            }
        },

        viewWillAppear: function () {
            var that = this;
            Tracking.track_field_tab_launch();
			Superclass.viewWillAppear.call(this);
            MessageService.addListener.call(that, VMEvents.UPDATE_FIELD_VIEW, this.onBeat);

			this.showOverlay();
		},

		viewDidAppear: function() {
			var that = this;
			Superclass.viewDidAppear.call(this);

            MessageService.publish(VMEvents.REQUEST_FIELD_VIEW_DATA);

			$(this.view).on('click', checkboxSelectors, function() {
                Tracking.track_field_activity();
                var showClasses=that.getVisibleClassNames();
                $('.onthefield',that.childWrapper).attr('class','').addClass('onthefield ' + showClasses);
                renderComplete(function(){
                    that.createTetherHoverData();
                });
			});
		},

		viewWillDisappear: function () {
			var that = this;

			if (this.onBeat) {

	            $(this.view).off('click', checkboxSelectors);
				MessageService.removeListener.call(that, VMEvents.UPDATE_FIELD_VIEW, that.onBeat);
				that.clearHitOutHoverContainers();
			}

			Superclass.viewWillDisappear.call(this);
		}
	});

	Superclass = FieldViewController.superclass;
    return FieldViewController;
});
